import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { PhoneCall, XCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { StatusBadge } from "../components/StatusBadge";
import { api } from "../lib/api";
export function UserDialer() {
    const [numbers, setNumbers] = useState([]);
    const [calls, setCalls] = useState([]);
    const [busyId, setBusyId] = useState("");
    const [cancellingId, setCancellingId] = useState("");
    async function refresh() {
        const [numberResult, callResult] = await Promise.all([api.userNumbers(), api.userCalls()]);
        setNumbers(numberResult.numbers);
        setCalls(callResult.calls);
    }
    useEffect(() => {
        refresh();
        const timer = window.setInterval(() => api.userCalls().then(({ calls }) => setCalls(calls)), 3000);
        return () => window.clearInterval(timer);
    }, []);
    async function dial(id) {
        setBusyId(id);
        try {
            await api.dial(id);
            await refresh();
        }
        finally {
            setBusyId("");
        }
    }
    async function cancelCall(id) {
        setCancellingId(id);
        try {
            await api.cancelCall(id);
            await refresh();
        }
        finally {
            setCancellingId("");
        }
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "head", children: _jsxs("div", { children: [_jsx("span", { className: "eyebrow", children: "Support Service" }), _jsx("h1", { children: "\u8BF7\u6C42\u6280\u672F\u652F\u6301\u670D\u52A1" }), _jsx("p", { children: "\u8BF7\u9009\u62E9\u9700\u8981\u8BF7\u6C42\u7684\u670D\u52A1\u7C7B\u578B\uFF0C\u7CFB\u7EDF\u4F1A\u4E3A\u4F60\u521B\u5EFA\u4E00\u6761\u6280\u672F\u652F\u6301\u8BF7\u6C42\u3002" })] }) }), _jsxs("section", { className: "dial-grid", children: [numbers.map((number) => (_jsxs("button", { className: "dial-card", onClick: () => dial(number.id), disabled: busyId === number.id, children: [_jsx("span", { className: "dial-icon", children: _jsx(PhoneCall, { size: 22 }) }), _jsx("strong", { children: number.alias }), _jsx("small", { children: busyId === number.id ? "正在提交请求" : "请求服务" })] }, number.id))), !numbers.length ? _jsx("div", { className: "empty", children: "\u7BA1\u7406\u5458\u8FD8\u6CA1\u6709\u4E3A\u4F60\u914D\u7F6E\u53EF\u8BF7\u6C42\u7684\u670D\u52A1\u3002" }) : null] }), _jsx(RecentCalls, { calls: calls.slice(0, 6), cancellingId: cancellingId, onCancel: cancelCall })] }));
}
function RecentCalls({ calls, cancellingId, onCancel }) {
    return (_jsxs("section", { className: "card table-card", children: [_jsx("div", { className: "card-head", children: _jsx("strong", { children: "\u6700\u8FD1\u8BF7\u6C42" }) }), _jsxs("table", { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "\u65F6\u95F4" }), _jsx("th", { children: "\u522B\u79F0" }), _jsx("th", { children: "\u72B6\u6001" }), _jsx("th", { children: "\u64CD\u4F5C" })] }) }), _jsx("tbody", { children: calls.map((call) => (_jsxs("tr", { children: [_jsx("td", { children: new Date(call.createdAt).toLocaleString() }), _jsx("td", { children: call.alias }), _jsx("td", { children: _jsx(StatusBadge, { status: call.status }) }), _jsx("td", { children: call.status === "PENDING" ? (_jsxs("button", { type: "button", className: "btn secondary sm", onClick: () => onCancel(call.id), disabled: cancellingId === call.id, children: [_jsx(XCircle, { size: 13 }), cancellingId === call.id ? "取消中" : "取消"] })) : (_jsx("span", { className: "muted", children: "-" })) })] }, call.id))) })] })] }));
}
